import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import PatientSidebar from "./PatientSidebar";
import "../Styles/patientsidebar.css";

const PatientLayout = () => {
  const [completedSections, setCompletedSections] = useState({});

  const markSectionComplete = (sectionIndex) => {
    setCompletedSections((prev) => ({
      ...prev,
      [sectionIndex]: true,
    }));
  };

  return (
    <div className="patient-layout">
      <PatientSidebar completedSections={completedSections} />
      <div className="patient-form-container">
        {/* 👇 Pass context to children */}
        <Outlet context={{ markSectionComplete }} />
      </div>
    </div>
  );
};

export default PatientLayout;
